module.exports = __webpack_public_path__ + "media/images/icons/icon_multi_heart_hand-beea078e16c51c6f8f7b32335759277f.svg";